export interface Input extends Marko.SVG.SVG {}

<svg ...input width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.75 4.75C7.75 3.7835 6.9665 3 6 3C5.0335 3 4.25 3.7835 4.25 4.75V15.25C4.25 16.2165 5.0335 17 6 17C6.9665 17 7.75 16.2165 7.75 15.25V4.75ZM15.75 4.75C15.75 3.7835 14.9665 3 14 3C13.0335 3 12.25 3.7835 12.25 4.75V15.25C12.25 16.2165 13.0335 17 14 17C14.9665 17 15.75 16.2165 15.75 15.25V4.75Z"
        fill="currentColor"/>
</svg>
